<template>
    <v-card class="my-1" @click="onClickItem" :loading="loading">
        <v-card-text>
            <v-list-item three-line class="px-0">
                <v-list-item-title>
                    <v-chip small label class="mr-1">{{item.ra}}</v-chip>
                    <v-chip small label class="mr-1">{{item.sstatus}}</v-chip>
                    <v-chip small label class="mr-1">{{item.turno}}</v-chip>
                    <h5 class="mt-1">{{item.nome}}</h5>
                </v-list-item-title>
                <v-list-item-subtitle>
                    <b>{{item.habilitacao}} - {{item.codturma}} - {{item.codperlet}}</b>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.respfin_nome">
                    <h5>
                        <helper-gdb text="Responsável Financeiro" icon="mdi-cash"/>
                        {{item.respfin_nome}}
                    </h5>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.respacad_nome">
                    <h5>
                        <helper-gdb text="Responsável Acadêmico" icon="mdi-school"/>
                        {{item.respacad_nome}}
                    </h5>
                </v-list-item-subtitle>
            </v-list-item>
            <helper-gdb text="ItemAlunoPesquisa" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props: {
        item: {
            required: true
        },
        loading: {
            default: false
        }
    },
    methods: {
        onClickItem(){
            if (this.loading) return
            this.$emit('on-click-item', this.item)
        }
    }
}
</script>
